export const getters = {
  platformSettings: (state) => state.platformDetails && state.platformDetails.platFormSettings,
  multiLanguageEnabled: (state) =>
    state.platformDetails &&
    state.platformDetails.platFormSettings &&
    state.platformDetails.platFormSettings.ENABLE_MULTILANGUAGE &&
    (state.platformDetails.platFormSettings.ENABLE_MULTILANGUAGE.toString().toLowerCase() === 'yes' ||
      state.platformDetails.platFormSettings.ENABLE_MULTILANGUAGE === true)
};
